import {
	api_methods
} from '../../service/loadData'

import {
	INIT_BUYLRP,SET_LRPTCONFIG
} from './mutation-types.js'

export default {
	
	
}